/* Reliable in-page navigation for the LBHH desktop header and mobile drawer. */
(() => {
  const decodeHash = (hash) => {
    try {
      return decodeURIComponent(hash.replace(/^#/, ''));
    } catch (_error) {
      return hash.replace(/^#/, '');
    }
  };

  const getTarget = (hash) => {
    const id = decodeHash(hash);
    return id ? document.getElementById(id) : null;
  };

  const revealTarget = (target) => {
    if (target.matches('details')) target.open = true;
    target.querySelectorAll(':scope > details').forEach((details) => {
      if (details.id === target.id) details.open = true;
    });
    let parent = target.parentElement?.closest('details');
    while (parent) {
      parent.open = true;
      parent = parent.parentElement?.closest('details');
    }
  };

  const closeNavigation = () => {
    const drawer = document.querySelector('header-drawer');
    const mainDrawer = drawer?.querySelector('#Details-menu-drawer-container');
    if (mainDrawer) {
      mainDrawer.removeAttribute('open');
      mainDrawer.classList.remove('menu-opening');
      mainDrawer.querySelectorAll('details').forEach((details) => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      mainDrawer.querySelectorAll('.submenu-open').forEach((submenu) => submenu.classList.remove('submenu-open'));
      document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop');
      document.querySelector('.section-header')?.classList.remove('menu-open');
    }

    document.querySelectorAll('.header__inline-menu details[open]').forEach((details) => {
      details.removeAttribute('open');
      details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    });
  };

  const scrollToHash = (hash, updateHistory = false) => {
    const target = getTarget(hash);
    if (!target) return false;

    revealTarget(target);
    closeNavigation();

    window.setTimeout(() => {
      const headerHeight = document.querySelector('.section-header')?.getBoundingClientRect().height || 0;
      const top = target.getBoundingClientRect().top + window.scrollY - headerHeight - 12;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      if (updateHistory && window.location.hash !== hash) history.pushState(null, '', hash);
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }, 80);

    return true;
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="#"]');
    if (!link || link.target === '_blank' || event.defaultPrevented) return;

    const url = new URL(link.href, window.location.href);
    if (!url.hash || url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
    if (!getTarget(url.hash)) return;

    event.preventDefault();
    scrollToHash(url.hash, true);
  });

  window.addEventListener('hashchange', () => scrollToHash(window.location.hash));
  window.addEventListener('load', () => {
    if (window.location.hash) window.setTimeout(() => scrollToHash(window.location.hash), 120);
  });
})();
